const { isNil } = require("lodash");
const { countryCode, empty } = require("../shared");
const { createCollection, createModel, getFieldOptions } = require("../utils");
const { Joi, modelOptions } = require("../joi");

// @see: https://it.dpduk.live/it/diagram/diag_0Mtwb56GAqAADKUo.html
exports.product = createModel((_, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    productCode: Joi.string()
      .max(255)
      .allow(empty)
      .example("12121212")
      .options(fieldOptions),
    productDescription: Joi.string()
      .max(200)
      .example("SHOES")
      .options(fieldOptions),
    countryOfOrigin: countryCode().options(fieldOptions),
    productQty: Joi.number()
      .integer()
      .min(1)
      .max(99999)
      .example(2)
      .required()
      .options(fieldOptions),
    unitWeight: Joi.number()
      .min(0.01)
      .max(99999.99)
      .example(2.0)
      .required()
      .options(fieldOptions),
    unitValue: Joi.number()
      .min(0.01)
      .max(99999.99)
      .example(1.0)
      .required()
      .options(fieldOptions),
    productType: Joi.string()
      .max(40)
      .allow(empty)
      .options(fieldOptions),
    productComposition: Joi.string()
      .max(200)
      .example("COTTON")
      .allow(empty)
      .options(fieldOptions),
    commodityCode: Joi.string()
      .min(1)
      .max(10)
      .allow(empty)
      .example("27101955")
      .options(fieldOptions),
    productUrl: Joi.string()
      .allow(empty)
      .options(fieldOptions),
  };
});

const updateOriginReason = error => {
  if (error.context.reason) {
    for (let i = 0, len = error.context.reason.length; i < len; i++) {
      updateOriginReason(error.context.reason[i]);
    }

    return;
  }

  if (!error.message) {
    error.message = getErrorMessage(error);

    const suffixPath = getItemSuffixPath(error);

    if (suffixPath.length) {
      error.message += ` ${suffixPath}`;
    }
  }
};

/**
 *  Allow to create item path in appropriate format
 *  @example parcel 1, product 1
 */
const getItemSuffixPath = error => {
  const messages = [];
  const parcelPos = error.path.findIndex(el => el === "parcels");

  if (parcelPos !== -1 && !isNil(error.path[parcelPos + 1])) {
    messages.push(`Parcel ${error.path[parcelPos + 1] + 1}`);
  }

  const productPos = error.path.findIndex(el => el === "products");

  if (productPos !== -1 && !isNil(error.path[productPos + 1])) {
    messages.push(`Product ${error.path[productPos + 1] + 1}`);
  }
  return messages.length ? `(${messages.join(", ")})` : "";
};

const getErrorMessage = error => {
  const originMethod = error.toString;
  const message = error.toString();

  error.toString = originMethod.bind(error);
  return message;
};

exports.updateParcelProductMessageSuffix = errors => {
  errors.forEach(error => {
    updateOriginReason(error);
  });

  return errors;
};

exports.products = createCollection((prefix, options = {}) =>
  Joi.array()
    .items(exports.product(prefix, options))
    .error(exports.updateParcelProductMessageSuffix)
    .options(modelOptions)
);
